/**
 * 排出事業者詳細
 * 登録パターン
 */
import Vue from "vue";
import * as httpConst from "../../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emissions`;

const emission_entry_pattern = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    /**
     * 排出に紐付く登録パターン取得
     * @param commit
     * @param id { Number } 排出事業者ID
     * @param page { Number } ページ番号
     * @return {Promise<unknown>}
     */
    index({ commit }, { id, page }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}/entry_patterns`, { params: { page: page } }).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 登録パターン取得
     * @param commit
     * @param emission_id { Number } 排出事業者ID
     * @param id { Number } 登録パターンID
     * @return {Promise<unknown>}
     */
    show({ commit }, { emission_id, id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${emission_id}/entry_patterns/${id}`).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 登録パターン編集情報取得
     * @param commit
     * @param emission_id { Number } 排出事業者ID
     * @param id { Number } 登録パターンID
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { emission_id, id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${emission_id}/entry_patterns/${id}/edit`).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 登録パターン更新登録
     * @param commit
     * @param emission_id { Number } 排出事業者ID
     * @param id { Number } 登録パターンID
     * @param params { Object } 登録パターン
     */
    update({ commit }, { emission_id, id, params }) {
      return new Promise((resolve) => {
        Vue.$http.put(`${API_PATH}/${emission_id}/entry_patterns/${id}`, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "更新しました" },
            { root: true }
          );
          resolve(content);
        });
      });
    },
    /**
     * 登録パターン削除
     * @param commit
     * @param emission_id { Number } 排出事業者ID
     * @param id { Number } 登録パターンID
     * @return {Promise<unknown>}
     */
    destroy({ commit }, { emission_id, id }) {
      return new Promise((resolve) => {
        Vue.$http.delete(`${API_PATH}/${emission_id}/entry_patterns/${id}`).then((data) => {
          commit(
            "snackbar/showInfo",
            { message: "削除しました" },
            { root: true }
          );
          resolve(data.content);
        });
      });
    },


  },
  mutations: {},
};

export default emission_entry_pattern;
